class UserGroup {
  constructor(title, description) {
    this.title = title;
    this.description = description;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      //edit permission
      permissionModal: false,
      allUserGroupSelectedPermissions: [],
      allUserGroupPermissions: [],
      //edit role
      roleModal: false,
      allUserGroupRoles: [],
      allUserGroupSelectedRoles: [],
      confimType: '',
      userGroupId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      provinceTitle: '',
      userGroupManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'توضیحات', value: 'description', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchText: '',
      actionList: [
        {
          title: 'ویرایش سطح دسترسی',
          id: '1',
          type: 'permisions',
          icon: 'mdi-account-lock mdi-18px',
        },
        {
          title: 'ویرایش نقش ها',
          id: '2',
          type: 'roles',
          icon: 'mdi-account-cog mdi-18px',
        },
        {
          title: 'کنترل زمان دسترسی',
          id: '3',
          type: 'times',
          icon: 'mdi-clock-time-four mdi-18px',
        },
        { title: 'حذف', id: '4', type: 'delete', icon: 'mdi-delete mdi-18px' },
      ],
    };
  },
  methods: {
    setActionType: function (type, data) {
      if (type == 'permisions') {
        this.confimType = 'permission';
        this.userGroupId = data.id;
        this.showEditPermissionModal();
      } else if (type == 'roles') {
        this.confimType = 'role';
        this.userGroupId = data.id;
        this.showEditRoleModal();
      } else if (type == 'delete') {
        this.userGroupId = data.id;
        this.confimType = 'delete';
        this.showConfirmDialogFunction();
      }
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن گروه کاربری';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش گروه کاربری';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getUserGroupFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.userGroup = new UserGroup('', '');
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addUserGroupFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش گروه کاربری';
        this.$refs.confirm.text = 'از ویرایش گروه کاربری اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف گروه کاربری';
        this.$refs.confirm.text = 'از حذف گروه کاربری اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'permission') {
        this.$refs.confirm.title = 'ویرایش سطح دسترسی';
        this.$refs.confirm.text = 'از ویرایش سطح دسترسی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'role') {
        this.$refs.confirm.title = 'ویرایش نقش';
        this.$refs.confirm.text = 'از ویرایش نقش اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addUserGroupFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editUserGroupFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteUserGroupFunction();
      } else if (this.confimType == 'permission') {
        this.disabelConfirm = true;
        this.EditUserGroupPermissionFunction();
      } else if (this.confimType == 'role') {
        this.disabelConfirm = true;
        this.EditUserGroupRoleFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'permission') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'role') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //permission part
    showEditPermissionModal: function () {
      this.allUserGroupSelectedPermissions = [];
      this.allUserGroupPermissions = [];
      this.getAllPermissions();
    },
    readyUserGroupPermission: function () {
      this.getUserGroupPermissionList();
    },
    defineUserGroupPermissions: function () {
      if (this.allUserGroupSelectedPermissions.length > 0) {
        for (let i = 0; i < this.allUserGroupPermissions.length; i++) {
          for (let j = 0; j < this.allUserGroupSelectedPermissions.length; j++) {
            if (this.allUserGroupPermissions[i].id === this.allUserGroupSelectedPermissions[j].id) {
              this.allUserGroupPermissions.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.permissionModal = true;
    },
    addPermssionToUserGroupPermissions: function (permission) {
      this.allUserGroupSelectedPermissions.push(permission);
      for (let i = 0; i < this.allUserGroupPermissions.length; i++) {
        if (permission.id == this.allUserGroupPermissions[i].id) {
          this.allUserGroupPermissions.splice(i, 1);
          break;
        }
      }
    },
    removePermissionFromUserGroupPermissions: function (permission) {
      this.allUserGroupPermissions.push(permission);
      for (let i = 0; i < this.allUserGroupSelectedPermissions.length; i++) {
        if (permission.id == this.allUserGroupSelectedPermissions[i].id) {
          this.allUserGroupSelectedPermissions.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserGroupPermision: function () {
      this.allUserGroupSelectedPermissions = [];
      this.allUserGroupPermissions = [];
      this.permissionModal = false;
    },
    //role part
    showEditRoleModal: function () {
      this.allUserGroupSelectedRoles = [];
      this.allUserGroupRoles = [];
      this.getAllRoles();
    },
    readyUserGroupRole: function () {
      this.getUserGroupRoleList();
    },
    defineUserGroupRoles: function () {
      if (this.allUserGroupSelectedRoles.length > 0) {
        for (let i = 0; i < this.allUserGroupRoles.length; i++) {
          for (let j = 0; j < this.allUserGroupSelectedRoles.length; j++) {
            if (this.allUserGroupRoles[i].id === this.allUserGroupSelectedRoles[j].id) {
              this.allUserGroupRoles.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.roleModal = true;
    },
    addRoleToUserGroupRoles: function (role) {
      this.allUserGroupSelectedRoles.push(role);
      for (let i = 0; i < this.allUserGroupRoles.length; i++) {
        if (role.id == this.allUserGroupRoles[i].id) {
          this.allUserGroupRoles.splice(i, 1);
          break;
        }
      }
    },
    removeRoleFromUserGroupRoles: function (role) {
      this.allUserGroupRoles.push(role);
      for (let i = 0; i < this.allUserGroupSelectedRoles.length; i++) {
        if (role.id == this.allUserGroupSelectedRoles[i].id) {
          this.allUserGroupSelectedRoles.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserGroupRole: function () {
      this.allUserGroupSelectedRoles = [];
      this.allUserGroupRoles = [];
      this.roleModal = false;
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfUserGroupsWithPagination();
    },
    removeFilters: function () {
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfUserGroupsWithPagination();
    },
    cancelSearch: function () {
      this.searchText = '';
      this.searchModal = false;
    },
    goToUserGroupUsers: function (id) {
      this.$router.push({ name: 'userGroupUsers', params: { id: id } });
    },
  },
};
